/**
 * Cal.com Global Constants
 * These values serve as the primary source of truth for Cal.com integration.
 * They are configurable via environment variables or fallback to these defaults.
 */

export const CAL_LINK = import.meta.env.VITE_CAL_LINK || 'm2xlab-ai/30min';
export const CAL_BRAND_COLOR = import.meta.env.VITE_CAL_BRAND_COLOR || '#9333ea';
export const CAL_ORIGIN = import.meta.env.VITE_CAL_ORIGIN || 'https://app.cal.com';

export const CAL_CONFIG = {
  styles: {
    branding: {
      brandColor: CAL_BRAND_COLOR,
    },
  },
  hideEventTypeDetails: false,
  layout: 'month_view',
} as const;
